let mdi_list = [
    {
        question: "SPECIFICATIONS FOR THE DRUG PRODUCT",
        answer:
            <ul>
                <li>Description</li>
                <li>Identification (Primary and secondary)
                </li>
                <li>Water Content
                </li>
                <li>Dehydrated Alcohol Content
                </li>
                <li>Net Content (Fill) Weight
                </li>
                <li>Drug Content (Assay)
                </li>
                <li>Impurities and Degradation Products
                </li>
                <li>Foreign particulate matter
                </li>
                <li>Dose Content Uniformity
                </li>
                <li>Dose Content Uniformity Through Container Life
                </li>
                <li>Particle Size Distribution
                </li>
                <li>Aerodynamic particle size distribution
                </li>
                <li>Microscopic Evaluation
                </li>
                <li>Spray Pattern and Plume Geometry
                </li>
                <li>Leak Rate
                </li>
                <li>Pressure Testing
                </li>
                <li>Valve Delivery (Shot Weight)
                </li>
            </ul>
    },
    {
        question: "DRUG PRODUCT CHARACTERIZATION STUDIES FOR SUBMISSION",
        answer:
            <ul>
                <li>Determination of Appropriate Storage Conditions
                </li>
                <li>Stability of Primary (Unprotected) Package
                </li>
                <li>Temperature Cycling
                </li>
                <li>Effect of Resting Time
                </li>
                <li>Priming/ Re-priming
                </li>
                <li>Effect of Storage on the Particle Size Distribution
                </li>
                <li>Drug Deposition on Mouthpiece and/or Accessories
                </li>
                <li>Cleaning Instructions
                </li>
                <li>Profiling of Actuations Near Canister Exhaustion
                </li>
                <li>Plume Geometry
                </li>
                <li>Photo stability
                </li>
                <li>Profiling of Doses Near Device Exhaustion
                </li>
                <li>In Vitro Dose Proportionality
                </li>
                <li>Effect of Varying Flow Rates
                </li>
                <li>Cleaning Instructions
                </li>
            </ul>
    },
    {
        question:
            "IN-VITRO BIO- EQUIVALENCE WITH STATISTICAL ANALYSIS (FOR SUBMISSION)",
        answer:
            <ul>
                <li>APSD (test and Reference) with critical stage PBE
                </li>
                <li>Single actuation content (test and Reference) (SAC) with PBE
                </li>
                <li>Spray pattern
                </li>
                <li>Plume geometry
                </li>
                <li>Q1-Q2 comparison
                </li>
            </ul>
    },
    {
        question:
            "INNOVATIVE IN-VITRO TESTING",
        answer:
            <ul>
                <li>BRS 3000 -Improving IVIVCs for MDIs</li>
                <li>Dissolution Testing with and without using anatomical throat
                </li>
                <li>APSD study with anatomical throat
                </li>
                <li>Particle size and shape of API in formulation
                </li>
            </ul>

    },
];
export default mdi_list;